import { render } from "./app-text-tooltip.vue?vue&type=template&id=3e4a4408&scoped=true"
import script from "./app-text-tooltip.vue?vue&type=script&lang=js"
export * from "./app-text-tooltip.vue?vue&type=script&lang=js"

import "./app-text-tooltip.vue?vue&type=style&index=0&id=3e4a4408&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4a4408"]])

export default __exports__